import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=89974036"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89974036')) {
      api.createRecord('89974036', component.options)
    } else {
      api.reload('89974036', component.options)
    }
    module.hot.accept("./Activity.vue?vue&type=template&id=89974036", function () {
      api.rerender('89974036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Activity/Activity.vue"
export default component.exports